import {
  __asyncGenerator,
  __await,
  __forAwait,
  __spreadProps,
  __spreadValues
} from "../chunk-LMOQIXV4.js";
import { visit } from "graphql";
import { meros } from "meros/browser";
import {
  isAsyncIterable,
  makeAsyncIterableIteratorFromSink
} from "@n1ru4l/push-pull-async-iterable-iterator";
const errorHasCode = (err) => typeof err == "object" && err !== null && "code" in err, byteLength = (value) => typeof TextEncoder == "undefined" ? value.length : new TextEncoder().encode(value).length, headersToObject = (headers) => {
  const headersLike = headers;
  if (!headersLike || typeof headersLike.forEach != "function")
    return;
  const result = {};
  return headersLike.forEach((value, key) => {
    result[key] = value;
  }), result;
};
async function readResponseBody(response) {
  const raw = await response.text();
  try {
    return { body: JSON.parse(raw), raw };
  } catch (e) {
    return {
      body: { errors: [{ message: raw || response.statusText || `Empty response (status ${response.status})` }] },
      raw
    };
  }
}
function toTransportResponse(body, response, startMs, { requestBody, rawResponseText } = {}) {
  var _a, _b;
  const errors = body == null ? void 0 : body.errors, hasErrors = Array.isArray(errors) && errors.length > 0, contentLength = (_b = (_a = response.headers) == null ? void 0 : _a.get) == null ? void 0 : _b.call(_a, "content-length");
  return {
    ok: response.ok && !hasErrors,
    status: response.status,
    statusText: response.statusText,
    headers: headersToObject(response.headers),
    body,
    timing: { totalMs: performance.now() - startMs },
    size: {
      request: requestBody === void 0 ? void 0 : byteLength(requestBody),
      response: contentLength ? Number(contentLength) : byteLength(rawResponseText != null ? rawResponseText : JSON.stringify(body))
    }
  };
}
const isSubscriptionWithName = (document, name) => {
  let isSubscription = !1;
  return visit(document, {
    OperationDefinition(node) {
      var _a;
      name === ((_a = node.name) == null ? void 0 : _a.value) && node.operation === "subscription" && (isSubscription = !0);
    }
  }), isSubscription;
};
function buildGetUrl(baseUrl, graphQLParams) {
  const params = new URLSearchParams();
  params.set("query", graphQLParams.query), graphQLParams.operationName != null && params.set("operationName", graphQLParams.operationName), graphQLParams.variables != null && params.set("variables", JSON.stringify(graphQLParams.variables)), graphQLParams.extensions != null && params.set("extensions", JSON.stringify(graphQLParams.extensions));
  const sep = baseUrl.includes("?") ? "&" : "?";
  return `${baseUrl}${sep}${params.toString()}`;
}
const simpleHttpTransport = (options, httpFetch, method = "POST") => async (graphQLParams, fetcherOpts) => {
  const startMs = performance.now();
  if (method === "GET") {
    const url = buildGetUrl(options.url, graphQLParams), response2 = await httpFetch(url, {
      method: "GET",
      signal: fetcherOpts == null ? void 0 : fetcherOpts.signal,
      headers: __spreadValues(__spreadValues({
        accept: "application/graphql-response+json, application/json;q=0.9"
      }, options.headers), fetcherOpts == null ? void 0 : fetcherOpts.headers)
    }), { body: body2, raw: raw2 } = await readResponseBody(response2);
    return toTransportResponse(body2, response2, startMs, {
      rawResponseText: raw2
    });
  }
  const requestBody = JSON.stringify(graphQLParams), response = await httpFetch(options.url, {
    method,
    body: requestBody,
    signal: fetcherOpts == null ? void 0 : fetcherOpts.signal,
    headers: __spreadValues(__spreadValues({
      "content-type": "application/json",
      accept: "application/graphql-response+json, application/json;q=0.9"
    }, options.headers), fetcherOpts == null ? void 0 : fetcherOpts.headers)
  }), { body, raw } = await readResponseBody(response);
  return toTransportResponse(body, response, startMs, {
    requestBody,
    rawResponseText: raw
  });
}, createSimpleFetcher = (options, httpFetch) => async (graphQLParams, fetcherOpts) => (await httpFetch(options.url, {
  method: "POST",
  body: JSON.stringify(graphQLParams),
  headers: __spreadValues(__spreadValues({
    "content-type": "application/json",
    accept: "application/graphql-response+json, application/json;q=0.9"
  }, options.headers), fetcherOpts == null ? void 0 : fetcherOpts.headers)
})).json();
async function createWebsocketsFetcherFromUrl(url, connectionParams) {
  let wsClient;
  try {
    const { createClient } = await import("graphql-ws");
    return wsClient = createClient({ url, connectionParams }), createWebsocketsFetcherFromClient(wsClient);
  } catch (err) {
    if (errorHasCode(err) && err.code === "MODULE_NOT_FOUND")
      throw new Error(
        "You need to install the 'graphql-ws' package to use websockets when passing a 'subscriptionUrl'"
      );
    console.error(`Error creating websocket client for ${url}`, err);
  }
}
const createWebsocketsFetcherFromClient = (wsClient) => (graphQLParams) => makeAsyncIterableIteratorFromSink(
  (sink) => wsClient.subscribe(graphQLParams, __spreadProps(__spreadValues({}, sink), {
    error(err) {
      err instanceof CloseEvent ? sink.error(
        new Error(
          `Socket closed with event ${err.code} ${err.reason || ""}`.trim()
        )
      ) : sink.error(err);
    }
  }))
), createLegacyWebsocketsFetcher = (legacyWsClient) => (graphQLParams) => {
  const observable = legacyWsClient.request(graphQLParams);
  return makeAsyncIterableIteratorFromSink(
    // @ts-ignore
    (sink) => observable.subscribe(sink).unsubscribe
  );
}, MULTIPART_ACCEPT = "multipart/mixed, application/graphql-response+json;q=0.9, application/json;q=0.8", multipartHttpTransport = (options, httpFetch, method = "POST") => function(graphQLParams, fetcherOpts) {
  return __asyncGenerator(this, null, function* () {
    const startMs = performance.now();
    let rawResponse, requestBody;
    if (method === "GET") {
      const url = buildGetUrl(options.url, graphQLParams);
      rawResponse = yield new __await(httpFetch(url, {
        method: "GET",
        signal: fetcherOpts == null ? void 0 : fetcherOpts.signal,
        headers: __spreadValues(__spreadValues({
          accept: MULTIPART_ACCEPT
        }, options.headers), fetcherOpts == null ? void 0 : fetcherOpts.headers)
      }));
    } else
      requestBody = JSON.stringify(graphQLParams), rawResponse = yield new __await(httpFetch(options.url, {
        method,
        body: requestBody,
        signal: fetcherOpts == null ? void 0 : fetcherOpts.signal,
        headers: __spreadValues(__spreadValues({
          "content-type": "application/json",
          accept: MULTIPART_ACCEPT
        }, options.headers), fetcherOpts == null ? void 0 : fetcherOpts.headers)
      }));
    const response = yield new __await(meros(rawResponse, { multiple: !0 }));
    if (!isAsyncIterable(response)) {
      const { body, raw } = yield new __await(readResponseBody(response));
      yield toTransportResponse(body, rawResponse, startMs, {
        requestBody,
        rawResponseText: raw
      });
      return;
    }
    try {
      for (var iter = __forAwait(response), more, temp, error; more = !(temp = yield new __await(iter.next())).done; more = !1) {
        const chunk = temp.value;
        if (chunk.some((part) => !part.json)) {
          const message = chunk.map(
            (part) => `Headers::
${part.headers}

Body::
${part.body}`
          );
          throw new Error(
            `Expected multipart chunks to be of json type. got:
${message}`
          );
        }
        yield toTransportResponse(
          chunk.map((part) => part.body),
          rawResponse,
          startMs,
          { requestBody }
        );
      }
    } catch (temp) {
      error = [temp];
    } finally {
      try {
        more && (temp = iter.return) && (yield new __await(temp.call(iter)));
      } finally {
        if (error)
          throw error[0];
      }
    }
  });
}, createMultipartFetcher = (options, httpFetch) => function(graphQLParams, fetcherOpts) {
  return __asyncGenerator(this, null, function* () {
    const response = yield new __await(httpFetch(options.url, {
      method: "POST",
      body: JSON.stringify(graphQLParams),
      headers: __spreadValues(__spreadValues({
        "content-type": "application/json",
        accept: "application/json, multipart/mixed"
      }, options.headers), fetcherOpts == null ? void 0 : fetcherOpts.headers)
    }).then(
      (r) => meros(r, {
        multiple: !0
      })
    ));
    if (!isAsyncIterable(response))
      return yield response.json();
    try {
      for (var iter = __forAwait(response), more, temp, error; more = !(temp = yield new __await(iter.next())).done; more = !1) {
        const chunk = temp.value;
        if (chunk.some((part) => !part.json)) {
          const message = chunk.map(
            (part) => `Headers::
${part.headers}

Body::
${part.body}`
          );
          throw new Error(
            `Expected multipart chunks to be of json type. got:
${message}`
          );
        }
        yield chunk.map((part) => part.body);
      }
    } catch (temp) {
      error = [temp];
    } finally {
      try {
        more && (temp = iter.return) && (yield new __await(temp.call(iter)));
      } finally {
        if (error)
          throw error[0];
      }
    }
  });
};
async function getWsFetcher(options, fetcherOpts) {
  if (options.wsClient)
    return createWebsocketsFetcherFromClient(options.wsClient);
  if (options.subscriptionUrl)
    return createWebsocketsFetcherFromUrl(options.subscriptionUrl, __spreadValues(__spreadValues({}, options.wsConnectionParams), fetcherOpts == null ? void 0 : fetcherOpts.headers));
  if (options.legacyWsClient)
    return createLegacyWebsocketsFetcher(options.legacyWsClient);
}
export {
  createLegacyWebsocketsFetcher,
  createMultipartFetcher,
  createSimpleFetcher,
  createWebsocketsFetcherFromClient,
  createWebsocketsFetcherFromUrl,
  getWsFetcher,
  isSubscriptionWithName,
  multipartHttpTransport,
  simpleHttpTransport
};
